<template>
  <div>
    <vs-popup title="Çeki Listesi" button-cancel="border" :active.sync="isSidebarActiveLocal" fullscreen
      @cancel="isSidebarActiveLocal = false" @close="isSidebarActiveLocal = false" classContent="popup-example">
      <b-row>
        <b-col>
          <b-form-datepicker id="baslangic" @input="getCekiList" v-model="listDateStart" size="sm" local="en" class="mb-2"
            today-variant="danger" placeholder="-" :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }" />
        </b-col>
        <b-col>
          <b-form-datepicker id="baslangic" @input="getCekiList" v-model="listDateEnd" size="sm" local="en" class="mb-2"
            today-variant="danger" placeholder="-" :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }" />
        </b-col>
      </b-row>

      <ag-grid-vue style="width: 100%; height: 400px; margin-top: 25px" class="ag-theme-alpine" :excelStyles="excelStyles"
        :defaultColDef="defaultColDef" :columnDefs="columnDefs" :rowData="rowdata" :localeText="localeText"
        @grid-ready="onGridReady" @first-data-rendered="onFirstDataRendered" :rowSelection="rowSelection">
      </ag-grid-vue>
      <vs-prompt color="warning" title="UYARI" acceptText="Sil" cancelText="Vazgeç" @accept="deleteCeki(deletedValue)"
        :active.sync="activePromptStockUpdate"> Silmek istediğinize emin misiniz ?
      </vs-prompt>
    </vs-popup>
  </div>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import TextGorunumCellRenderer from "./CellRenderers/TextGorunumCellRenderer.vue";
import CekiListesiExcelDetayBtnVue from "../components/uzum-components/paketleme-components/CekiListesiExcelDetayBtn.vue";
export default {
  data() {
    return {
      deletedValue: "",
      activePromptStockUpdate: false,
      excelStyles: null,
      listDateStart: "",
      listDateEnd: "",
      rowSelection: null,
      rowdata: null,
      columnDefs: [],
      localeText: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: true,
        floatingFilter: true,
      },
    }
  },
  components: { AgGridVue, CekiListesiExcelDetayBtnVue, TextGorunumCellRenderer },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    sevkNumber: {
    },
  },
  methods: {
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    getCekiList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        marketplace: "Evidea", token: Store.state.tokenId, listDateStart: vm.listDateStart, listDateEnd: vm.listDateEnd, sevkNumber: vm.sevkNumber
      }; 
      soap.createClient(url, function (err, client) {
        client.cekiListesi(args, function (err, result) {
          vm.veriler = JSON.parse(result.cekiListesiResult); 
          vm.listDateStart = "";
          vm.listDateEnd = ""
          vm.columnDefs = [];

          vm.rowdata = vm.veriler
          vm.columnDefs.push({
            width: 150,
            field: "İşlemler",
            cellRendererFramework: "CekiListesiExcelDetayBtnVue",
            autoHeight: true,
            cellClassRules: {
              notInExcel: (params) => {
                return false;
              },
            },
          });
          let columnList = Object.keys(vm.rowdata[0]);
          columnList.forEach((val, index) => {
            if (val.includes("Tarihi")) {
              vm.columnDefs.push({
                field: val,
                filter: "agDateColumnFilter",
              });
            } else if (val.includes("Kalan Miktar")) {
              vm.columnDefs.push({
                field: val,
                filter: "agDateColumnFilter",
                cellClassRules: {
                  redFont: (params) => {
                    return params.value >= 0;
                  },
                },
              });
            } else if (val.includes("Gönderilen Miktar")) {
              vm.columnDefs.push({
                field: val,
                filter: "agDateColumnFilter",

                cellClass: ['greenBackground'],

              });
            } else if (val == "id") {

            }

            else
              vm.columnDefs.push({
                field: val,
                filter: "agSetColumnFilter",
                cellRenderer: "TextGorunumCellRenderer",

              });
          })

        });
      });
    },
    deleteCeki(param) {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        pazaryeri: "Evidea",
        token: Store.state.tokenId,
        id: param.id
      }; 
      soap.createClient(url, function (err, client) {
        client.cekiListesiSil(args, function (err, result) {
          try {
            vm.veriler = JSON.parse(result.cekiListesiSilResult);
            vm.getCekiList();
            vs.notify({
              title: "Çeki listesi",
              text: "Çeki listesi silme işlemi yapıldı",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            vs.notify({
              title: "Çeki listesi",
              text: "Çeki listesi silinemedi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }


        });
      });
    },
    deleteCekiList(param) {
      this.deletedValue = param
      this.activePromptStockUpdate = true
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

    },
  },
  watch: {
    isSidebarActive(val) { 
      //  if (val == true) this.yazdir();
      if (val == true) this.getCekiList();
      return val;
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
  },
  mounted() {
    this.$root.$on("deleteCekiList", params => {
      this.deleteCekiList(params);
    });
  },
  beforeDestroy() {
    this.$root.$off("deleteCekiList");
  },
  created() {
    this.rowSelection = "multiple";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.excelStyles = [
      {
        id: 'redFont',
        font: {
          fontName: 'Calibri Light',
          underline: 'Single',
          italic: true,
          color: '#BB0000',
        },
      },
      {
        id: 'greenBackground',
        interior: {
          color: '#b5e6b5',
          pattern: 'Solid',
        },
      },
    ];
  }
}
</script>

<style lang="scss">
.con-vs-popup .vs-popup {

  width: 1100px;
}

.con-vs-dialog {
  z-index: 5200555;
}

.greenBackground {
  background-color: #33cc3344;
  font-size: 30px;
  font-weight: bold;
}

.redFont {
  color: #bb0000;
}
</style>